import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";

import Others from "assets/images/hero-images/Banner_Others.png";
import BG from "assets/images/hero-images/BG.png";

function Enquiry() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Enquiry"
          title={`
              Let's
              <span className="jumbotron-subtitle-2">
                Connect
              </span>`}
          //   buttonText="Talk to us"
          //   footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={Others}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Enquiry;
